import { render, staticRenderFns } from "./MessagePlainText.vue?vue&type=template&id=1d7328b0&scoped=true"
import script from "./MessagePlainText.vue?vue&type=script&lang=js"
export * from "./MessagePlainText.vue?vue&type=script&lang=js"
import style0 from "./MessagePlainText.vue?vue&type=style&index=0&id=1d7328b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7328b0",
  null
  
)

export default component.exports